var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCreditCardJcb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.25h24c.966 0 1.75.784 1.75 1.75v16A1.75 1.75 0 0128 25.75H4A1.75 1.75 0 012.25 24V8c0-.966.784-1.75 1.75-1.75z",
    fill: "#fff",
    stroke: "#D1D1D1",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 20.178C25 21.733 23.746 23 22.205 23H7V11.822C7 10.267 8.254 9 9.795 9H25v11.178z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.049 17.294h1.155c.033 0 .11-.01.143-.01a.515.515 0 00.407-.518.534.534 0 00-.407-.517c-.033-.01-.099-.01-.143-.01H20.05v1.055z",
    fill: "url(#icon_credit_card_jcb_svg__paint0_linear_37861_244016)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10c-1.114 0-2 .89-2 2v2.08h2.873c.067 0 .145 0 .2.012.646.033 1.125.363 1.125.935 0 .45-.323.836-.924.913v.021c.657.045 1.158.408 1.158.968 0 .605-.557 1.001-1.292 1.001H19V22h3c1.114 0 2-.89 2-2.002V10h-3z",
    fill: "url(#icon_credit_card_jcb_svg__paint1_linear_37861_244016)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.611 15.16a.468.468 0 00-.407-.473c-.022 0-.077-.011-.11-.011H20.05v.968h1.045c.033 0 .1 0 .11-.01a.468.468 0 00.407-.474z",
    fill: "url(#icon_credit_card_jcb_svg__paint2_linear_37861_244016)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10c-1.114 0-2 .892-2 2.004v4.943c.568.275 1.17.451 1.76.451.701 0 1.08-.418 1.08-.99v-2.335h1.737v2.323c0 .903-.568 1.64-2.495 1.64-1.169 0-2.082-.253-2.082-.253V22h3c1.114 0 2-.892 2-2.004V10h-3z",
    fill: "url(#icon_credit_card_jcb_svg__paint3_linear_37861_244016)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 10a2 2 0 00-2 2.002v2.619c.506-.43 1.422-.704 2.841-.638.76.033 1.573.242 1.573.242v.847a3.81 3.81 0 00-1.518-.44c-1.078-.077-1.727.451-1.727 1.375 0 .935.649 1.464 1.727 1.376.627-.044 1.111-.242 1.518-.44v.847s-.803.209-1.573.242c-1.42.066-2.335-.21-2.841-.638V22h3c1.1 0 2-.889 2-2V10h-3z",
    fill: "url(#icon_credit_card_jcb_svg__paint4_linear_37861_244016)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_credit_card_jcb_svg__paint0_linear_37861_244016",
    x1: 19.068,
    y1: 16.768,
    x2: 24.012,
    y2: 16.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_credit_card_jcb_svg__paint1_linear_37861_244016",
    x1: 19.009,
    y1: 15.995,
    x2: 24.014,
    y2: 15.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_credit_card_jcb_svg__paint2_linear_37861_244016",
    x1: 19.068,
    y1: 15.159,
    x2: 24.012,
    y2: 15.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_credit_card_jcb_svg__paint3_linear_37861_244016",
    x1: 8.009,
    y1: 16.001,
    x2: 13.09,
    y2: 16.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_credit_card_jcb_svg__paint4_linear_37861_244016",
    x1: 13.507,
    y1: 15.997,
    x2: 18.383,
    y2: 15.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })))));
}

export default SvgIconCreditCardJcb;